export default "__VITE_ASSET__BQ_$iSHd__"